import React from 'react';
import styled from 'styled-components';

import ModalContent from '#/components/basic/modal/components/ModalContent';
import ModalFooterButtons from '#/components/basic/modal/components/ModalFooterButtons';
import Callout from '#/components/s2/Callout/Callout';
import config from '#/config';

const Text = styled.p`
  font-size: var(--medium2);
  line-height: 1.5;
  margin-top: 0;
`;

export default function DelegatedKeyConsentModal({
  onContinue,
}: {
  onContinue: () => void;
}) {
  return (
    <>
      <ModalContent>
        <Text>
          Session Keys are valid for {config.delegatedKeyExpirationDays} days
          and can be exported for use in other applications.{' '}
        </Text>
        <Text>
          For security purposes, Session Keys are only displayed upon creation
          and hidden afterwards.
        </Text>
        <Callout type="warn">
          Do not share your Session Keys with any untrusted third party
        </Callout>
      </ModalContent>
      <ModalFooterButtons
        confirmButtonProps={{ onClick: onContinue, children: 'Understood' }}
      />
    </>
  );
}
